import { render, staticRenderFns } from "./editorUpoad.vue?vue&type=template&id=77a58ed1&scoped=true"
import script from "./editorUpoad.vue?vue&type=script&lang=js"
export * from "./editorUpoad.vue?vue&type=script&lang=js"
import style0 from "./editorUpoad.vue?vue&type=style&index=0&id=77a58ed1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a58ed1",
  null
  
)

export default component.exports